import { del, get, post } from "../common/apiClient";

const PATH_AUTH = "/auth";
const login = async (body) => {
  return await post(PATH_AUTH + "/login-admin", body, {
    withCredentials: true,
  });
};

const checkJwtExistsAndExpired = () => {
  // Access token lưu ở HttpOnly cookie -> FE không đọc được
  // Nếu đã đăng nhập admin thì vẫn giữ trạng thái local (tạm dùng user trong storage)
  const user = localStorage.getItem("user");
  return !!user;
};
const logoutSession = async () => {
  // return await del(PATH_AUTH + `/sessions`);
};

export { login, checkJwtExistsAndExpired, logoutSession };
